import { Component, OnInit, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { NgForm } from '@angular/forms'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'

import { SiteService } from '../../../../services/site.service'
import { MessageService } from '../../../../services/message.service'
import { TranslateService } from '@ngx-translate/core'
import { CustomerRequestsService } from '../../../../services/customer-requests.service'

import { otherChangeViewModel } from '../../../../models/otherChangeViewModel'
import { ErrorMessageModalComponent } from '../../../modals/error-message-modal/error-message-modal.component'

@Component({
    selector: 'app-request-other-change-detail',
    templateUrl: './request-other-change-detail.component.html',
    styleUrls: ['./request-other-change-detail.component.scss'],
    standalone: false
})
export class RequestOtherChangeDetailComponent implements OnInit 
{
  @ViewChild('customForm') public customForm!: NgForm
  formSubmitted: boolean = false
  isActiveLease: boolean = true

  request =
  {
    changeRequestNote: ''
  }
  referenceNumber: string = ''
  otherChangeViewModel = new otherChangeViewModel()

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private siteService: SiteService,
    private messageService: MessageService,
    private translateService: TranslateService,
    private customerRequestsService: CustomerRequestsService
  ) 
  { 
  }

  ngOnInit() 
  {
    this.retrieveOtherChangeRequestViewModel()
  }

  retrieveOtherChangeRequestViewModel()
  {
    this.messageService.startedHttpRequest('retrieveOtherChangeRequestViewModel')
    this.customerRequestsService
      .getOtherChangeRequestViewModel()
			.subscribe({
				next: (apiResponse) =>
        {
          this.otherChangeViewModel = apiResponse

          if(this.otherChangeViewModel && this.otherChangeViewModel.leaseNumber && this.otherChangeViewModel.leaseNumber != '')
          {
          }
          else
          {
            this.isActiveLease = false
          }
        },
				error: (error) =>
				{
          this.isActiveLease = false
          this.messageService.completedHttpRequest('retrieveOtherChangeRequestViewModel')
      
          const dialogConfig = new MatDialogConfig()
          dialogConfig.width = '500px',
          dialogConfig.data = {
            title: this.translateService.instant('COMMON_LBL_ERROR'),
            message: this.translateService.instant('COMMON_LBL_ERROR_MSG')
          }		
          this.dialog.open(ErrorMessageModalComponent, dialogConfig)
				},
				complete: () =>
				{
					this.messageService.completedHttpRequest('retrieveOtherChangeRequestViewModel')
				}
			})
  }

  submitForm(customerForm: NgForm)
  {
    this.formSubmitted = true

    if (customerForm.invalid)
    {
      return
    }

    const requestSummaryList: { key: string; value: string }[] = [
      { key: this.translateService.instant('REQUEST_OTHER_CHANGE_CONFIRM_NAME'), value: this.siteService.customerAccount?.fullName ?? '' },
      { key: this.translateService.instant('REQUEST_OTHER_CHANGE_CONFIRM_LEASENUM'), value: this.otherChangeViewModel.leaseNumber },
      { key: this.translateService.instant('REQUEST_OTHER_CHANGE_CONFIRM_NOTE'), value: this.request.changeRequestNote }
    ]

    return this.customerRequestsService.requestConfirmation(this.translateService.instant('REQUEST_OTHER_CHANGE_CONFIRM_PRINT_TITLE'), requestSummaryList)
    .then((result) =>
    {
      if(result)
      {
        let changeRequest =
        {
          changeRequestNote: this.request.changeRequestNote
        }

        this.messageService.startedHttpRequest('submitForm')
        this.customerRequestsService
        .addOtherChangeRequest(changeRequest)
        .subscribe({
          next: (apiResponse) =>
          {
            this.referenceNumber = apiResponse

            if ((this.referenceNumber != undefined) && (this.referenceNumber != ''))
            {
              this.customerRequestsService.requestSummary(this.referenceNumber, this.translateService.instant('REQUEST_OTHER_CHANGE_HEADING'), requestSummaryList)
            
              this.router.navigate(['/request-list'])
            }	
                          
            this.formSubmitted = false
          },
          error: (error) =>
          {
            this.messageService.completedHttpRequest('submitForm')
      
            const dialogConfig = new MatDialogConfig()
            dialogConfig.width = '500px',
            dialogConfig.data = {
              title: this.translateService.instant('COMMON_LBL_ERROR'),
              message: this.translateService.instant('COMMON_LBL_ERROR_MSG')
            }		
            this.dialog.open(ErrorMessageModalComponent, dialogConfig)
          },
          complete: () =>
          {
            this.messageService.completedHttpRequest('submitForm')
          }
        })
      }
    })
  }
}
